import type { ProjectAssignFormProps } from "./project-assign-form.type";
import type { ModelAssignFormValues } from "@/modules/model-assign";

import { useProjectAssign } from "@/entities/project";

export const useProjectAssignForm = ({
  project,
  options,
}: ProjectAssignFormProps) => {
  const { mutate, status, error } = useProjectAssign(project.id, options);

  const onFormSubmit = (values: ModelAssignFormValues) => {
    const users = values.users.map((user) => user.value);
    return mutate(users);
  };

  return {
    onFormSubmit,
    status,
    error,
  };
};
